export const MODAL_SALIDA_LEYENDA = [
    'Estás por abandonar nuestra web institucional. El Banco no se',
    'responsabiliza sobre la nueva página a la cual estás por ingresar.',
];
export const MODAL_SALIDA_TITULO = 'AVISO';
